import {
  faBriefcase,
  faChartMixed,
  faTableLayout,
} from "@fortawesome/pro-regular-svg-icons";
import { useLocation } from "react-router-dom";
import { useLocalStorage } from "usehooks-ts";

import { useCaseAnalyticsAccess } from "src/cases/analytics/useCaseAnalyticsAccess";
import { CaseTemplatesNavSection } from "src/cases/templates/CaseTemplatesNavSection";
import { useCapabilities } from "src/hooks/useCapabilities";
import { NavItem, NavSidebar } from "src/layout/NavSideBar";
import { FEATURE_FLAGS, isFeatureFlagEnabled } from "src/router/featureFlags";
import {
  DashboardPageParams,
  getUrlToCaseAnalyticsPage,
  getUrlToCaseQueuePage,
  getUrlToCaseTemplatesPage,
} from "src/router/urls";
import { useParamsDecode } from "src/utils/useParamsDecode";

export const CaseNavSidebar: React.FC = () => {
  const { orgId, wsId } = useParamsDecode<DashboardPageParams>();
  const { caseAnalytics, caseTemplates } = useCapabilities();
  const { canAccess: caseAnalyticsEnabled } = useCaseAnalyticsAccess();
  const { pathname } = useLocation();
  const [collapsed, setCollapsed] = useLocalStorage(
    "caseNavigationCollapsed",
    false,
  );

  if (
    !caseAnalyticsEnabled ||
    (!caseAnalytics.canAccess && !caseTemplates.canAccess)
  ) {
    return null;
  }

  const isQueuesPage =
    !pathname.includes("/analytics") && !pathname.includes("/templates");

  return (
    <div className="border-gray-100 border-l">
      <NavSidebar collapsed={collapsed} setCollapsed={setCollapsed}>
        {caseAnalytics.canAccess && (
          <NavItem
            dataLoc="case-analytics"
            icon={faChartMixed}
            title="Analytics"
            to={getUrlToCaseAnalyticsPage(orgId, wsId)}
          />
        )}
        <NavItem
          dataLoc="case-queues"
          icon={faBriefcase}
          isActiveOverride={isQueuesPage}
          neverShowActive
          title="Queues"
          to={getUrlToCaseQueuePage({ orgId, wsId })}
        />
        {caseTemplates.canAccess &&
          (isFeatureFlagEnabled(FEATURE_FLAGS.caseAnalytics) ? (
            <CaseTemplatesNavSection
              canCreate={caseTemplates.canCreate}
              collapsed={collapsed}
              orgId={orgId}
              wsId={wsId}
            />
          ) : (
            <NavItem
              dataLoc="case-templates"
              icon={faTableLayout}
              title="Case templates"
              to={getUrlToCaseTemplatesPage(orgId, wsId)}
            />
          ))}
      </NavSidebar>
    </div>
  );
};
